import script from "./PrayerWall.vue?vue&type=script&setup=true&lang=js"
export * from "./PrayerWall.vue?vue&type=script&setup=true&lang=js"

import "./PrayerWall.vue?vue&type=style&index=0&id=2fff1e2a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fff1e2a"]])

export default __exports__